(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["furlio-dispatch-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('furlio-dispatch-note')) {
    customElements.define('furlio-dispatch-note', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section, dialog');
        this.controller = new AbortController();

        import('@shopify/events').then(({ StandardEvents }) => {
          if (!this.isConnected) return;

          this.scope?.addEventListener(StandardEvents.productSelect, async (event) => {
            if (event.target instanceof Element && event.target.closest('product-card')) return;

            try {
              const result = await event.promise;
              const detail = result?.detail;

              if (!detail?.html) return;
              if (detail.productId && String(detail.productId) !== this.dataset.productId && !detail.newProduct) return;

              const replacement = Array.from(
                detail.html.querySelectorAll('furlio-dispatch-note')
              ).find(node => node.dataset.blockId === this.dataset.blockId);

              if (replacement) {
                this.innerHTML = replacement.innerHTML;
                this.dataset.productId = replacement.dataset.productId;
              } else {
                this.replaceChildren();
              }
            } catch (error) {
              if (error?.name !== 'AbortError') {
                console.warn('Dispatch notice could not refresh');
              }
            }
          }, { signal: this.controller.signal });
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
